<template>
  <div class="w-100 pa-2">
    <v-row>
      <v-col v-for="(item, i) in value" :key="i" cols="12" md="6">
        <v-card rounded="xxl" elevation="2">
          <!-- <v-card-item>
                <v-img></v-img>
            </v-card-item> -->

          <v-card-text>
            <v-card-title>{{ item.name }}</v-card-title>
          </v-card-text>

          <v-card-actions>
            <v-btn
              style="
                border-bottom-left-radius: 15px;
                border-bottom-right-radius: 15px;
              "
              color="primary"
              class="w-100"
              @click="(reserved = true), (selectSpace = item)"
            >
              <v-icon>mdi-view-grid-outline</v-icon>
              مشاهده فضاهای تبلیغاتی
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <custom-popup
      v-model="reserved"
      maxWidth="600px"
      maxHeight="600px"
      :cons="{ title: 'فضاهای تبلیغاتی' }"
    >
      <selectGateSpace v-model="selectSpace" />
    </custom-popup>
  </div>
</template>

<script>
import selectGateSpace from "./gate/selectGateSpace.vue";
export default {
  name: "reserveSpace",
  components: { selectGateSpace },
  data() {
    return {
      // value of spae
      value: [
        {
          id: 1,
          name: "اسانسور",
          items: [
            {
              id: 1,
              active: true,
              name: "اسانسور شماره ۱",
              pay: {
                day: 1000,
                week: 1200,
                month: 1300,
                treeMonth: 1400,
                sixMonth: 1500,
                year: 3000,
              },
            },
          ],
        },
        {
          id: 2,
          name: "بالکن",
          items: [
            {
              id: 1,
              active: true,
              name: "بالکن جنوبی",
              pay: {
                day: 1000,
                week: 1200,
                month: 1300,
                treeMonth: 1400,
                sixMonth: 1500,
                year: 3000,
              },
            },
            {
              id: 2,
              active: true,
              name: "بالکن شمالی",
              pay: {
                day: 1000,
                week: 1200,
                month: 1300,
                treeMonth: 1400,
                sixMonth: 1500,
                year: 3000,
              },
            },
          ],
        },
      ],
      //   select space
      selectSpace: {},
      // modal
      reserved: false,
    };
  },

  watch: {
    reserved: {
      immediate: false,
      handler(val) {
        if (!val) {
          this.selectSpace = {};
        }
      },
    },
  },
};
</script>

<style></style>
